import React from 'react';
import './App.css';

import backgroundImage1 from "./assets/background.jpg";
import Header from "./components/header_bis"; 
import Part1 from "./components/part1"; 
import Section1 from "./components/section1"; 
import MultiImageCarousel from "./components/gallery"
import Contact from "./components/contact"
import Support from "./components/supports"

function App() {
    const images = [backgroundImage1, backgroundImage1, backgroundImage1];  // Utilisation des images importées

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
  };

  return (
    <>
      <Header />
      <Part1 />
      <Section1 />
      <Support />
      <MultiImageCarousel />
      <Contact />
    </>

  );
}

export default App;